import React from 'react'

function Options({ list, receive_sms, receive_emails, changeOption }) {
  return (
    <div className="options">
        <label htmlFor="messages-options" className="title-label highlight" style={{width: '100%'}}>Chcę otrzymywać powiadomienia:</label>
        <div className="option highlight">
            <input type="checkbox" id="receive-emails"  name="receive-emails" value="receive_emails" checked={receive_emails} onClick={() => changeOption('receive_emails')}/>
            <label htmlFor="receive-emails">e-mail o nadejściu pytania od klienta</label>
        </div>
        <div className="option highlight">
            <input type="checkbox" id="receive-sms" name="receive-sms" value="receive_sms" checked={receive_sms} onClick={() => changeOption('receive_sms')}/>
            <label htmlFor="receive-sms">sms z informacją, że klient chce się umówić na spotkanie</label>
        </div>
        {list}        
    </div>
  )
}

export default Options